import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

export default function LanguageToggle() {
    const { i18n } = useTranslation();

    const languages = [
        { code: "fa", label: "فارسی", shortLabel: "Fa", flag: "🇮🇷", dir: "rtl" },
        { code: "en", label: "English", shortLabel: "EN", flag: "🇺🇸", dir: "ltr" },
        { code: "ar", label: "العربية", shortLabel: "Ar", flag: "🇸🇦", dir: "rtl" },
        { code: "tr", label: "Türkçe", shortLabel: "Tr", flag: "🇹🇷", dir: "ltr" },
    ];

    const currentLanguage = languages.find((lang) => lang.code === i18n.language);

    const handleLanguageChange = (langCode: string) => {
        i18n.changeLanguage(langCode);
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm" className="text-base font-medium mt-0.5 text-[#5D697F] hover:text-[#155DFC] hover:bg-transparent px-2 gap-1 min-w-fit group">
                    {currentLanguage?.shortLabel || "EN"}
                    <ChevronDown className="h-4 w-4 transition-transform duration-300 group-data-[state=open]:rotate-180" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="start"
                className="mt-6 z-[100000] min-w-[140px] bg-white/95 backdrop-blur-md border border-gray-200/50 shadow-lg rounded-xl p-1 animate-in fade-in-0 zoom-in-95 duration-200"
            >
                {languages.map((lang) => (
                    <DropdownMenuItem
                        key={lang.code}
                        onClick={() => handleLanguageChange(lang.code)}
                        className={`
                            cursor-pointer rounded-lg px-4 py-2.5 transition-all duration-200
                            ${i18n.language === lang.code ? "bg-[#155DFC]/10 text-[#155DFC] font-semibold shadow-sm" : "text-[#5D697F] hover:bg-blue-50/50 hover:text-[#155DFC]"}
                        `}
                    >
                        <span className="flex items-center gap-2 text-sm">
                            <span>{lang.flag}</span>
                            <span>{lang.label}</span>
                        </span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
